<div class="container" *ngIf="visible">
  <div class="text-start">
    <p [innerHTML]="'CLIENT_WEB.COOKIE_CONSENT' | translate"></p>
    <div class="text-end">
      <app-cancel-button (click)="decline()" [text]="'CLIENT_WEB.COOKIE_DECLINE' | translate"></app-cancel-button>
      <app-default-search-button (click)="accept()" [text]="'CLIENT_WEB.COOKIE_ACCEPT' | translate"></app-default-search-button>
    </div>
  </div>
</div>
